import axios, { AxiosResponse } from 'axios'
import { ArquivoDto, AtendimentosQueryResponse } from '../../../atendimento/core/_models'
import { AssinaturaLoteDto, AssinaturaLoteResultadoDto } from './_models'
import { AssinaturaType } from '../../../../../../_metronic/helpers'

const API_URL = process.env.REACT_APP_API_URL
const ATENDIMENTO_URL = `${API_URL}/atendimentos`

/**
 * ASO - Assinatura do atestado
 * @param atendimendoId Identificador do atendimento
 * @param tipo AssinaturaType
 * @returns ArquivoDto
 */
export const signAso = (atendimendoId: number, tipo: AssinaturaType): Promise<ArquivoDto> => {
  return axios
    .put(`${ATENDIMENTO_URL}/aso/sign/${atendimendoId}`, { tipo })
    .then((d: AxiosResponse<ArquivoDto>) => d.data)
}

/**
 * ASO - Assinatura de atestados em lote
 * @param assinaturaLote AssinaturaLoteDto
 * @returns AssinaturaLoteResultadoDto
 */
export const signAsoLote = (
  assinaturaLote: AssinaturaLoteDto
): Promise<AssinaturaLoteResultadoDto> => {
  return axios
    .put(`${ATENDIMENTO_URL}/aso/sign`, assinaturaLote)
    .then((d: AxiosResponse<AssinaturaLoteResultadoDto>) => d.data)
}

/**
 * Busca os atendimentos ASO não assinados pelo profissional auntenticado
 * @param query string
 * @returns AtendimentosQueryResponse - AtendimentoList[]
 */
export const getAtendimentosAsoNotSigned = (query: string): Promise<AtendimentosQueryResponse> => {
  return axios
    .get(`${ATENDIMENTO_URL}/aso/responsavel/assinar?${query}`)
    .then((d: AxiosResponse<AtendimentosQueryResponse>) => d.data)
}
